
  const user = {
    path: "/user",
    name: "user",
    component: () => import(/* webpackChunkName: "user" */ "@/components/user/UserIndex.vue"),
    children: [
      { path: "view/:id", component: () => import(/* webpackChunkName: "user" */ "@/components/user/UserView.vue"), name: "userView" },
      { path: "edit/:id", component: () => import(/* webpackChunkName: "user" */ "@/components/user/UserEdit.vue"), name: "userEdit" },
      { path: "create", component: () => import(/* webpackChunkName: "user" */ "@/components/user/UserCreate.vue"), name: "userCreate"}
    ],
    meta: { authorize: [], requiresAuth: true }
  };

export default user;
    